// extracted by mini-css-extract-plugin
export default {"box":"Promocao_box__LS0Bg"};